import { createContext, useContext } from "react";
import logo from "../assets/logo-peugeot.png";
import brand from "../assets/gruposva.jpeg";

/* Models */
import active208 from "../assets/molelos/208active.png";
import at208 from "../assets/molelos/208at.png";
import p2008 from "../assets/molelos/p2008.png";
import partner from "../assets/molelos/partner.png";

export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const prices = {
    plusat: {
      cuota: "333.111",
      valor: "29.890.000",
      anticipo: "6.766.000"
    },
    plus: {
      cuota: "423.000",
      valor: "28.450.000",
      anticipo: "7.106.000"
    },
    easy: {
      cuota: "308.000",
      valor: "28.450.000",
      anticipo: "6.766.000"
    },
    p2008: {
      cuota: "509.000",
      valor: "32.900.000",
      anticipo: "13.023.000"
    },
    partner: {
      cuota: "454.000",
      valor: "26.140.000",
      anticipo: "10.710.000"
    }
  };

  const modelos = [
    /*  {
       id: 1,
       nombre: "208 Plus AT",
       modelo: "Peugeot 208 ALLURE AT AM25",
       cuota: prices.plusat.cuota,
       plan: `Plan 70% Financiado`,
       text1: "1 Año de Nafta Gratis",
       text2: `Valor Contado $${prices.plusat.valor}`,
       test3: "Retira en Cuota 7 SIN ANTICIPO",
       img: at208,
       dataButton: "Plan Plus AT"
     }, */
    {
      id: 2,
      nombre: "208 ALLURE MT",
      modelo: "Peugeot 208 ALLURE MT",
      cuota: prices.plus.cuota,
      plan: `PLAN 70/30`,
      text1: "TOMAMOS TU USADO",
      text2: `Tenelo con anticipo $${prices.plus.anticipo}`,
      test3: "LLAVE POR LLAVE",
      img: active208,
      dataButton: "Plan Plus"
    },
    /*    {
         id: 3,
         nombre: "208 Easy",
         modelo: "Peugeot 208 ALLURE AM25",
         cuota: prices.easy.cuota,
         plan: `Plan 70% Financiado`,
         text1: "1 Año de Nafta Gratis",
         text2: `Valor Contado $${prices.easy.anticipo}`,
         test3: "Retira en Cuota 7 SIN ANTICIPO",
         img: active208,
         dataButton: "Plan 208 Active"
       }, */
    {
      id: 4,
      nombre: "2008 ACTIVE SUV",
      modelo: "Peugeot Nuevo 2008 ACTIVE",
      cuota: prices.p2008.cuota,
      plan: `PLAN 70/30`,
      text1: "TOMAMOS TU USADO",
      text2: `Tenelo con anticipo $${prices.p2008.anticipo}`,
      test3: "LLAVE POR LLAVE",
      img: p2008,
      dataButton: "Plan 2008"
    },
    {
      id: 5,
      nombre: "Partner",
      modelo: "Peugeot PARTNER CONFORT 1.6 HDI 92 AM22.5",
      cuota: prices.partner.cuota,
      plan: `PLAN 70/30`,
      text1: "TOMAMOS TU USADO",
      text2: `Tenelo con anticipo $${prices.partner.anticipo}`,
      test3: "LLAVE POR LLAVE",
      img: partner,
      dataButton: "Plan Partner"
    }
  ];

  const themeOptions = {
    acentcolor: "#00a3e0",
    dealer: "Grupo SVA",
    carBrand: "Peugeot",
    brand: brand,
    logo: logo,
    urlHook: "https://hook.us1.make.com/ph2kah6wog3xkvgjufvb6i95q36f1vyp"
  };

  const modelsOptions = modelos.map((model) => {
    return {
      value: model.dataButton,
      text: `${model.dataButton} (Cuota $${model.cuota})`,
      disabled: model.disabled
    };
  });

  console.log(modelsOptions);

  return (
    <ConsContext.Provider
      value={{
        prices,
        modelos,
        modelsOptions,
        themeOptions
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
